import script from "./InterestConfirmModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./InterestConfirmModal.vue?vue&type=script&lang=ts&setup=true"

import "./InterestConfirmModal.vue?vue&type=style&index=0&id=64f97fdf&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3182222765/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64f97fdf"]])

export default __exports__